import { render, staticRenderFns } from "./perubahan_nir.vue?vue&type=template&id=73eb688a&"
import script from "./perubahan_nir.vue?vue&type=script&lang=js&"
export * from "./perubahan_nir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports